export default "__VITE_ASSET__WgxNaoeH__";